require("!!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/script-loader/addScript.js")(require("!!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/raw-loader/index.js!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/bootstrap/dist/js/bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.js
// module id = 587
// module chunks = 11